import { useContext } from "react";
import { FeaturesContext } from "./FeaturesContext";

export default () => {
    const context = useContext(FeaturesContext);

    if (context === undefined) throw new Error("useFeatures must be used within a FeaturesProvider");

    return context;
};
